// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aD8uqignmJR46DTHgTm1 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: var(--curio-z-modal-base-backdrop);
}

.E2g6Quz5omLBa17cw36a {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  max-width: 90vw;
  max-height: 80vh;
  background: var(--curio-card-bg);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-modal);
  z-index: var(--curio-z-modal-base);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* The focus trap focuses the dialog itself when nothing in it has the focus.
   The dialog is not a control, so it draws no ring; its controls keep theirs. */
.E2g6Quz5omLBa17cw36a:focus {
  outline: none;
}

/* Wider than the default, still as tall as its content. */
.N2SiPdw2RpTNnivFAdHN {
  width: min(640px, 90vw);
}

.qC9O8m1ffO4lOO9e0cV0 {
  width: min(720px, 50vw);
  height: min(720px, 70vh);
  max-width: none;
  max-height: none;
}

.Bxt8m3G5VhBoIkmSaKZd {
  width: min(1200px, max(320px, calc(100vw - 452px)));
  height: calc(100vh - 32px);
  max-width: none;
  max-height: none;
  background: #f7f7f4;
}

/* Center in the canvas area left of the dataset catalog drawer (~420px). */
.bbeR3xWS_lkN15J1SiZD {
  left: max(16px, calc((100vw - 420px) / 2));
  transform: translate(-50%, -50%);
}

.eL_TPw9xcDm8Z9880lkk {
  z-index: var(--curio-z-modal-backdrop);
}

.mVaTQhXcOTkuC4KuXxOe {
  z-index: var(--curio-z-modal);
}

.fH3Wmi2Oq8b2UWpR2QcX {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  font-size: 16px;
  background: none;
  border: none;
  line-height: 1;
  color: var(--curio-text-primary);
  padding: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fH3Wmi2Oq8b2UWpR2QcX:hover {
  color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalShell.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;gFACgF;AAChF;EACE,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: var(--curio-z-modal-base-backdrop);\n}\n\n.modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 480px;\n  max-width: 90vw;\n  max-height: 80vh;\n  background: var(--curio-card-bg);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-modal);\n  z-index: var(--curio-z-modal-base);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* The focus trap focuses the dialog itself when nothing in it has the focus.\n   The dialog is not a control, so it draws no ring; its controls keep theirs. */\n.modal:focus {\n  outline: none;\n}\n\n/* Wider than the default, still as tall as its content. */\n.wide {\n  width: min(640px, 90vw);\n}\n\n.large {\n  width: min(720px, 50vw);\n  height: min(720px, 70vh);\n  max-width: none;\n  max-height: none;\n}\n\n.xlarge {\n  width: min(1200px, max(320px, calc(100vw - 452px)));\n  height: calc(100vh - 32px);\n  max-width: none;\n  max-height: none;\n  background: #f7f7f4;\n}\n\n/* Center in the canvas area left of the dataset catalog drawer (~420px). */\n.xlargeOverlay {\n  left: max(16px, calc((100vw - 420px) / 2));\n  transform: translate(-50%, -50%);\n}\n\n.backdropOverlay {\n  z-index: var(--curio-z-modal-backdrop);\n}\n\n.modalOverlay {\n  z-index: var(--curio-z-modal);\n}\n\n.closeX {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  cursor: pointer;\n  font-size: 16px;\n  background: none;\n  border: none;\n  line-height: 1;\n  color: var(--curio-text-primary);\n  padding: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.closeX:hover {\n  color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `aD8uqignmJR46DTHgTm1`,
	"modal": `E2g6Quz5omLBa17cw36a`,
	"wide": `N2SiPdw2RpTNnivFAdHN`,
	"large": `qC9O8m1ffO4lOO9e0cV0`,
	"xlarge": `Bxt8m3G5VhBoIkmSaKZd`,
	"xlargeOverlay": `bbeR3xWS_lkN15J1SiZD`,
	"backdropOverlay": `eL_TPw9xcDm8Z9880lkk`,
	"modalOverlay": `mVaTQhXcOTkuC4KuXxOe`,
	"closeX": `fH3Wmi2Oq8b2UWpR2QcX`
};
export default ___CSS_LOADER_EXPORT___;
